import { memo, useMemo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { IContactFlags } from 'clickNgo/entities/contactFlag'
import {
  BackupProvider,
  ContactDataContext,
} from 'clickNgo/features/contact/contactDeactivation/contexts'
import { ModalDialog } from 'core-components/library/modalDialog'

import { ContactRelinkingValidationModalContent } from './ContactRelinkingValidationModalContent'
import { ReassignmentProvider } from './contexts/ReassignmentContext'

import styles from './ContactRelinkingValidationModal.module.scss'

type Props = {
  contact: IContact
  contactFlags: IContactFlags
  isVisible: boolean
  onRelink: (newHpRoles?: string[]) => void
  onClose: () => void
  relinkingNewPartnerId: string
}

export const ContactRelinkingValidationModal = memo<Props>(
  ({ contact, contactFlags, isVisible, onClose, onRelink, relinkingNewPartnerId }) => {
    const contactDataValue = useMemo(
      () => ({
        contact,
        contactFlags,
      }),
      [contact, contactFlags]
    )

    return (
      <ContactDataContext.Provider value={contactDataValue}>
        <ReassignmentProvider>
          <BackupProvider>
            <ModalDialog
              classes={styles}
              show={isVisible}
              content={() => (
                <div className={styles.content}>
                  <ContactRelinkingValidationModalContent
                    onClose={onClose}
                    onRelink={onRelink}
                    relinkingNewPartnerId={relinkingNewPartnerId}
                  />
                </div>
              )}
              onClose={onClose}
              size="sm"
            />
          </BackupProvider>
        </ReassignmentProvider>
      </ContactDataContext.Provider>
    )
  }
)

ContactRelinkingValidationModal.displayName = 'ContactRelinkingValidationModal'
